export class Settings {
    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    public static readonly SymbolWild: number = 11;
    public static readonly SymbolBonus: number = 12;
    public static readonly SymbolTeasing: number = 12;
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/Settings.ts
 **/